import { Col, Image, Row, Typography } from 'antd';
import classNames from 'classnames/bind';
import { IMAGES } from '~/assets/assetsPath';
import styles from './Notification.module.scss';
import { getTimeAgo } from '~/utils/formatDayUtils';
import moment from 'moment';

const cx = classNames.bind(styles);
function NotificationItem({ noti, ...props }) {
    return (
        <div className={cx('wrapper__item', !noti?.seen && 'not__seen')} {...props}>
            <Row className={cx('box')} gutter={[8, 8]} align="middle">
                <Col md={{ span: 8 }} xs={{ span: 4 }}>
                    <Image
                        preview={false}
                        src={noti.image || IMAGES.ImagePlaceholder}
                        className={cx('image__noti')}
                        fallback={IMAGES.ImagePlaceholder}
                    />
                    <Image
                        preview={false}
                        src={noti.image || IMAGES.ImageLogoOn}
                        className={cx('image__noti_mobile')}
                        fallback={IMAGES.ImageLogoOn}
                    />
                </Col>
                <Col md={{ span: 16 }} xs={{ span: 20 }}>
                    <Row>
                        <Col span={24}>
                            <Typography.Title style={{ fontSize: '14px' }} level={5}>
                                {noti?.message_title}
                            </Typography.Title>
                        </Col>
                        <Col span={24}>
                            <Typography.Paragraph
                                style={{ fontSize: '12px' }}
                                ellipsis={{
                                    rows: 2,
                                    expandable: true,
                                    symbol: 'See more',
                                    onEllipsis: (ellipsis) => {
                                        console.log('Ellipsis changed:', ellipsis);
                                    },
                                    onExpand: (e) => {
                                        e.stopPropagation();
                                    },
                                }}
                            >
                                {noti?.message_content}
                            </Typography.Paragraph>
                        </Col>
                    </Row>
                    <Row align="middle">
                        <span className={cx('date')}>{moment(+noti?.created_at_unix_timestamp).format('HH:mm')}</span>
                        <div className={cx('space')}></div>
                        <span className={cx('date')}>{getTimeAgo(noti?.created_at_unix_timestamp)}</span>
                    </Row>
                </Col>

                {noti.seen && (
                    <Col span={24} className={cx('seen')}>
                        Watched
                    </Col>
                )}
            </Row>
        </div>
    );
}

export default NotificationItem;
